/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: timeGroupsActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Incoming Call Tools module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteTimeGroup } from './api/timeGroupApi';

/**
 * Shared helpers for Time Groups module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Time Group in the form.
 * Pattern: /pbx/incoming-tools/time-groups/new?duplicate={id}
 */
export const getTimeGroupDuplicateUrl = (id: string | number): string =>
  `/pbx/incoming-tools/time-groups/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Time Group id.
 */
export const navigateToTimeGroupDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getTimeGroupDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Time Group by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteTimeGroupById = async (id: string | number): Promise<void> => {
  await deleteTimeGroup(id);
};



